import { mutator } from 'satcheljs';
import { onEchoSuppresionChanged } from '../actions/internalActions';
import store from '../store/store';

/**
 * Mutator that sets the property echoGroupMessageBackToSubscribedSender
 */
export default mutator(onEchoSuppresionChanged, actionMessage => {
    store().echoGroupMessageBackToSubscribedSender = actionMessage.selectedOption;
});
